<template>
  <div class="navbar__wrapper">
    <nav class="navbar">
      <div class="navbar__tile-wrapper">
        <h1 class="navbar__title" @click="$router.push({ path: '/work ' })">{{ general[0].pageTitle }}</h1>
        <!-- <h1 class="navbar__title">{{ homepageData.titleline2 }}</h1> -->
      </div>
      <div class="navigation__wrapper">
        <ul class="navigation">
          <router-link :to="'/work'" class="navigation__item"><p class="nav__text">Work</p></router-link>
          <router-link :to="'/information'" class="navigation__item"><p class="nav__text">About</p></router-link>
          <!-- HIDE SIGN IN BUTTON -->
                
<!--          <router-link v-if="isAuthenticated" :to="'/profile'" class="navigation__item"><p class="nav__text">Profile</p></router-link>-->
          <!-- <router-link v-if="projects.length > 0" :to="'/projects'" class="navigation__item"><h1>Projects</h1></router-link> -->
          <!-- <a class="navigation__item" v-if="isAuthenticated">User: {{ getEmail }}</a> -->
<!--
          <p class="navigation__item nav__text" v-if="!isAuthenticated" @click='login()'>Sign In</p>
          <router-link v-if="isAuthenticated" :to="'/logout'">
            <p class="navigation__item nav__text" v-if="isAuthenticated" @click='logout()'>Log Out</p>
          </router-link>
-->
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'navigation',

  methods: mapActions(['login', 'logout']),

  computed: {
    ...mapGetters(['isAuthenticated', 'getRole', 'getEmail', 'general'])
  }
}
</script>
<style lang="scss">
@import "../scss/vars";

.navbar__wrapper {
  position: fixed;
  // width: calc(100% - 30px);
  width: 100%;
  top: 0;
  z-index: 7;
  padding: 0 24px;
  box-sizing: border-box;
  pointer-events: none;
}
.navbar {
  margin-right: auto;
  margin-left: auto;
  position: relative;
  display: flex;
  justify-content: space-between;
}
.navbar__title {
  cursor: pointer;
  pointer-events: all;
  &:hover {
    color: $ray-blue;
  }
    padding-top: 0.7rem;
  margin: 0;
}
.navigation__wrapper {
  pointer-events: all;

}
.navigation__item {
  cursor: pointer;
  &:hover {
    color: $font-color__second !important;
  }
}
a {
  text-decoration: none;
  color: $font-color__main;
}
.router-link-active {
  color: $font-color__second;
}
.navigation {
  margin: 0;
  display: flex;
  flex-flow: column;
}

.nav__text {
  font-size: $font-size-title;
  padding-top: 0.7rem;
  line-height: $font-size-title;
  margin: 0;
  text-align: right;
  font-weight: bold;
}

@media screen and (min-width: $break-small) {
  .navbar__wrapper {
    position: fixed;
    // width: calc(100% - 30px);
    width: 100%;
    top: 0;
    z-index: 7;
  }
  .navbar {
    margin: 0;
    position: relative;
    display: flex;
    justify-content: space-between;
    margin-top: 2.7rem;
  }
  .navigation__wrapper {
    pointer-events: all;
  }
  .navigation__item {
    cursor: pointer;
    &:hover {
      color: $font-color__second !important;
    }
  }
  a {
    text-decoration: none;
    color: $font-color__main;
  }
  .router-link-active {
    color: $font-color__second;
  }
  .navigation {
    display: flex;
    flex-flow: column;
  }
}
</style>
